import { lCache } from '@/helpers/log';
import { load, save } from './storage';
import moment from 'moment';
import { event } from 'vue-analytics';
const CACHE_KEY = 'data_cache';
const _cache = load(CACHE_KEY, () => ({}));
const _busy = {};
// on load, clean cache
(function () {
    const currentTs = moment().unix();
    let toDel = [];
    for (var key in _cache) {
        if (_cache[key].expiry < currentTs) {
            toDel.push(key);
        }
        else {
            setTimeout(() => del(key), (_cache[key].expiry - currentTs) * 1000);
        }
    }
    for (let key of toDel) {
        delete _cache[key];
    }
    save(CACHE_KEY, _cache);
})();
function set(key, expiry, data) {
    lCache('*SET', key);
    event('cache', 'set', key);
    _cache[key] = { data: data, expiry: moment().unix() + expiry };
    setTimeout(() => del(key), expiry * 1000);
    save(CACHE_KEY, _cache);
}
function del(key) {
    lCache('-DEL', key);
    event('cache', 'del', key);
    delete _cache[key];
    save(CACHE_KEY, _cache);
}
async function cache(key, expiry, cb) {
    // key = await hash(JSON.stringify(key))
    if (_cache[key]) {
        lCache('+HIT', key);
        event('cache', 'hit', key);
        await wait(200);
        return _cache[key].data;
    }
    // dedup multiple calls with same caching key
    if (_busy[key]) {
        let waitFnc = new Promise((resolve, reject) => {
            _busy[key].push({ resolve, reject });
        });
        return await waitFnc;
    }
    _busy[key] = [];
    try {
        lCache('*MIS', key);
        event('cache', 'mis', key);
        const data = await cb();
        for (let ob of _busy[key]) {
            ob.resolve(data);
        }
        delete _busy[key];
        if (data) {
            set(key, expiry, data);
            return data;
        }
    }
    catch (err) {
        for (let ob of _busy[key]) {
            ob.reject(err);
        }
        delete _busy[key];
        throw err;
    }
}
const w = window;
function textEncode(str) {
    if (w.TextEncoder) {
        return new w.TextEncoder('utf-8').encode(str);
    }
    var utf8 = unescape(encodeURIComponent(str));
    var result = new Uint8Array(utf8.length);
    for (var i = 0; i < utf8.length; i++) {
        result[i] = utf8.charCodeAt(i);
    }
    return result;
}
const cryp = w.crypto || w.msCrypto;
function hash(str) {
    // worst case, return full string
    if ((!cryp) || (!cryp.digest))
        return str;
    function hex(buffer) {
        var hexCodes = [];
        var view = new DataView(buffer);
        for (var i = 0; i < view.byteLength; i += 4) {
            var value = view.getUint32(i);
            var stringValue = value.toString(16);
            var padding = '00000000';
            var paddedValue = (padding + stringValue).slice(-padding.length);
            hexCodes.push(paddedValue);
        }
        return hexCodes.join('');
    }
    var buffer = textEncode(str);
    var res = cryp.subtle.digest('SHA-256', buffer);
    if (res.then) {
        return res.then(function (hash) {
            return hex(hash);
        });
    }
    else if (res.result) { // IE11
        return {
            then: function (resolver) {
                resolver(hex(res.result));
            }
        };
    }
}
function wait(val) {
    return new Promise((resolve) => {
        setTimeout(resolve, val);
    });
}
export default cache;
